"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecursoCriticoSubtipo = void 0;
var bson_1 = require("bson");
var RecursoCriticoSubtipo = /** @class */ (function () {
    function RecursoCriticoSubtipo(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.descricao, descricao = _c === void 0 ? '' : _c;
        this._id = _id;
        this.descricao = descricao;
    }
    return RecursoCriticoSubtipo;
}());
exports.RecursoCriticoSubtipo = RecursoCriticoSubtipo;
//# sourceMappingURL=RecursoCriticoSubtipo.js.map